
import geolocation from "./geolocation";
import gpsMockTrip from "./gpsMockTrip";
import Movement from "../../services/sharedServices/movement";
import { getServerDate } from "../storage/date";

export default class GpsMock {

    movement: Movement;
    mockGeolocation: any;
    mock: boolean;
    constructor(movementLibrary: Movement) {
        this.movement = movementLibrary;
        this.mockGeolocation = null;
        this.mock = false;
    }

    initialize(speedIsNull: boolean, constantTimeStamp = false) {
        let serverDate = getServerDate().getTime();
        let firstTimestamp;
        this.mockGeolocation = geolocation(gpsMockTrip.map(function (pos) {
            if (!firstTimestamp) {
                firstTimestamp = pos.timestamp;
            }
            let newPos = {
                ...pos,
                coords: {
                    ...pos.coords,
                    speed: speedIsNull ? null : pos.coords.speed
                },
                timestamp: serverDate + (pos.timestamp - firstTimestamp)
            };

            Object.defineProperties(newPos, {
                timestamp: {
                    get: () => constantTimeStamp ? serverDate : serverDate + (pos.timestamp - firstTimestamp) //pos.timestamp
                }
            });

            Object.defineProperties(newPos.coords, {
                speed: {
                    get: () => speedIsNull ? null : pos.coords.speed //pos.coords.speed
                },
                latitude: {
                    get: () => pos.coords.latitude
                },
                longitude: {
                    get: () => pos.coords.longitude
                },
                accuracy: {
                    get: () => pos.coords.accuracy
                },
                heading: {
                    get: () => pos.coords.heading
                }
            });

            return newPos;
        }));

        this.movement.stopTracking();
        this.movement.geolocation = this.mockGeolocation;
        this.movement.trackMovement();

        this.mock = true;
    }

    shutdown() {
        this.mock = false;

        if (this.movement.geolocation.mock) {
            this.movement.geolocation.clearWatch((this.movement.geolocation as any).currentTimeout);
        }

        this.movement.stopTracking();
        this.mockGeolocation = null;
        this.movement.geolocation = navigator.geolocation;
        this.movement.trackMovement();
    }
}